export const AppSettings = {
  continuationTokenHeader: 'x-syk-continuation'
}
